import { GridApi } from 'ag-grid-community';

import { AgGridDateComponent } from './ag-grid-date.component';

/**
 * Compares two dates, used for both filtering and sorting date columns
 * @param filterLocalDateAtMidnight - when filtering, this is the given date in filter field/ when sorting this is a first date to compare
 * @param cellValue - when filtering, this is the date in table cell/ when sorting this is a second date to compare
 * @returns comparison result
 */
export function agDateColumnFilterParamsComparator(filterLocalDateAtMidnight, cellValue): 0 | 1 | -1 {
  const dateAsString = cellValue;

  if (dateAsString == null) {
    return 0;
  }

  const cellDate = new Date(dateAsString);
  cellDate.setHours(0, 0, 0, 0);

  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
}

export const AG_DATE_FILTER_PARAMS = {
  comparator: agDateColumnFilterParamsComparator,
  includeTime: false,
  inRangeFloatingFilterDateFormat: 'DD.MM.YYYY',
};

export const AG_DATE_COL_CONFIG = {
  filter: 'agDateColumnFilter' as const,
  dateComponent: AgGridDateComponent,
  filterParams: AG_DATE_FILTER_PARAMS,
};

export function getGridElement(gridNameSelector = '#grid-wrapper'): HTMLElement {
  // eslint-disable-next-line no-restricted-globals
  return document.querySelector(gridNameSelector) as HTMLElement;
}

// Row count of 8 fits inside 300px, which was the original value
export function setGridHeightConditionally(gridApi: GridApi, gridNameSelector: string): void {
  const gridElement: HTMLElement = getGridElement(gridNameSelector);
  // when auto height is off, the grid has a fixed height, and then the grid
  // will provide scrollbars if the data does not fit into it.
  // auto height will get the grid to fill the height of the contents,
  // so the grid div should have no height set, the height is dynamic.
  gridElement.style.height = gridApi.getRenderedNodes().length > 8 ? '300px' : '';
}
